import api from "./api";

const getCompanyDetails = async () => {
  const response = await api.get(`/company-details`);
  return response.data;
};

const addCompanyDetails = async (companyDetailsData) => {
  const response = await api.post(`/company-details`, companyDetailsData);
  return response.data;
};

const updateCompanyDetails = async (companyDetailsData) => {
  const response = await api.put(`/company-details`, companyDetailsData);
  return response.data;
};

const companyDetailsService = {
  getCompanyDetails,
  addCompanyDetails,
  updateCompanyDetails,
};

export default companyDetailsService;
